import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { color } from '../../../../../style';

const EditColor = styled('span')(({ item, showPicker }) => ({
  display: 'block',
  height: 14,
  width: 14,
  borderRadius: item.type === 'board' ? 7 : 2,
  backgroundColor: item.color || '#ccc',
  border: showPicker ? `1px solid ${color.black}` : 'none'
}))

EditColor.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    color: PropTypes.string
  }).isRequired,
  showPicker: PropTypes.bool.isRequired
}

export default EditColor
